export default {"src":"/_next/static/media/java.c4924061.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};